import { useCallback, useEffect, useMemo } from "react";
import { Form } from "rsuite";
import { BillingInvoiceList, CustomDatePicker } from "../../../components";
import { Button } from "../../../components/button.component";
import { Card } from "../../../components/card.component";
import { AppRouteApi } from "../../../config/appRoute";
import {
  ActionsBillingInvoiceTable,
  useAppDispatch,
  useAppSelector,
} from "../../../core/redux";
import {
  IPaginationSearchFilter,
  useTablePaginationSearchFilter,
} from "../../../hooks";
import { ApiSchemaPaginatedBillingInvoice } from "../../../models/api";

export function PageInvoiceList() {
  const dispatch = useAppDispatch();
  const { pageNumber, nextPageToken, pageSize, startDate, endDate } =
    useAppSelector((state) => state.billingInvoiceTable);
  const apiParams = useMemo<IPaginationSearchFilter["customParams"]>(() => {
    return {
      PageNumber: pageNumber,
      NextPageToken: nextPageToken,
      PageSize: pageSize,
      StartDate: startDate,
      EndDate: endDate,
    };
  }, [pageNumber, pageSize, nextPageToken, startDate, endDate]);
  const { apiData } = useTablePaginationSearchFilter<
    ApiSchemaPaginatedBillingInvoice,
    typeof ActionsBillingInvoiceTable
  >(ActionsBillingInvoiceTable, {
    apiRoute: AppRouteApi.AdvancedInvoice.Invoices(),
    customParams: apiParams,
  });

  const resetData = useCallback(() => {
    dispatch(ActionsBillingInvoiceTable.resetData());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      resetData();
    };
  }, [resetData]);

  return (
    <Card
      header={
        <div className="row align-items-center justify-content-between">
          <div className="col-md-8 col-12 content-box-title">
            <div>
              <p className="text-capitalize my-1 text-green-200">
                Bills & Payments
              </p>
            </div>
            <div className="collapse-icon"></div>
          </div>
          <div className="col-4">
            <form className="search-component d-flex justify-content-end">
              {/* Search component can be empty but keep alignment consistent */}
            </form>
          </div>
        </div>
      }
    >
      <div className="mb-4 px-2 border-bottom border-1" id="filterPanel">
        {(endDate || startDate) && (
          <div className="d-flex justify-content-end mb-1">
            <Button
              name="Reset Filter Options"
              className="btn-danger btn-sm"
              onClick={resetData}
            >
              Reset Filter Options
            </Button>
          </div>
        )}

        <Form fluid>
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <CustomDatePicker
                  name="start"
                  action={ActionsBillingInvoiceTable}
                  value={startDate ? new Date(startDate) : null}
                >
                  Invoice Start Date
                </CustomDatePicker>
                <CustomDatePicker
                  name="end"
                  action={ActionsBillingInvoiceTable}
                  value={endDate ? new Date(endDate) : null}
                  setDate={ActionsBillingInvoiceTable.setEndDate}
                >
                  Invoice End Date
                </CustomDatePicker>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <BillingInvoiceList data={apiData} />
    </Card>
  );
}
